import { urlBase, urlPhp8 } from './urls';

const URL_BASE_PHP7 = `${urlBase}frontend/web/index.php?r=api`;
const URL_BASE_PHP8 = `${urlPhp8}frontend/web/index.php?r=api`;

export const URLS_PHP_7 = {
  cotizacion: {
    catalogosCotizador: `${URL_BASE_PHP7}/v1/cotizacion/catalogos-cotizador`,
    actualizarCotizacion: `${URL_BASE_PHP7}/v1/cotizacion/actualizar-cotizacion`,
    resumenCotizacion: `${URL_BASE_PHP7}/v1/cotizacion/resumen-cotizacion`,
    tarifacionCotizacion: `${URL_BASE_PHP7}/v1/cotizacion/tarifacion-cotizacion`,
    guardarPlanes: `${URL_BASE_PHP7}/v1/cotizacion/guardar-planes`,
    getPlanes: `${URL_BASE_PHP7}/v1/cotizacion/get-planes`,
    seccionPago: `${URL_BASE_PHP7}/v1/cotizacion/seccion-pago`,
    bloqueoRegional: `${URL_BASE_PHP7}/v1/cotizacion/bloqueo-regional`,
  },
  emision: {
    datosEmision: `${URL_BASE_PHP7}/v1/emision/datos-emision`,
    pago: `${URL_BASE_PHP7}/v1/emision/pago`,
    seccionCargaContratante: `${URL_BASE_PHP7}/v1/emision/seccion-carga-contratante`,
    seccionCargaAsegurado: `${URL_BASE_PHP7}/v1/emision/seccion-carga-asegurado`,
    listarAsegurados: `${URL_BASE_PHP7}/v1/emision/listar-asegurados`,
    catalogoAsegurado: `${URL_BASE_PHP7}/v1/emision/catalogo-asegurado`,
    guardarContratante: `${URL_BASE_PHP7}/v1/emision/guardado-contratante`,
    generarVigencia: `${URL_BASE_PHP7}/v1/emision/generar-vigencia-poliza`,
    guardarVigencia: `${URL_BASE_PHP7}/v1/emision/guardar-vigencia-poliza`,
  },
  hogarCommon: {
    generarVigencia: `${URL_BASE_PHP7}/v1/hogar/common/vigencia-poliza`,
    guardarVigencia: `${URL_BASE_PHP7}/v1/hogar/common/save-vigencia-poliza`,
    consultarGo4It: `${URL_BASE_PHP7}/v1/hogar/common/go4-it`,
    descargarPdfGo4It: `${URL_BASE_PHP7}/v1/hogar/common/descargar-pdf-go4-it`,
  },
  pymesCommon: {
    guardarContratante: `${URL_BASE_PHP7}/v1/pymes/common/guardar-contratante`,
    listarAsegurados: `${URL_BASE_PHP7}/v1/pymes/common/listar-asegurados`,
    actualizarAsegurados: `${URL_BASE_PHP7}/v1/pymes/common/actualizar-asegurados`,
    guardarVigenciaPoliza: `${URL_BASE_PHP7}/v1/pymes/common/guardar-vigencia-poliza`,
    generarVigenciaPoliza: `${URL_BASE_PHP7}/v1/pymes/common/generar-vigencia-poliza`,
    recotizar: `${URL_BASE_PHP7}/v1/pymes/common/recotizar`,
  },
};

export const URLS_PHP_8 = {
  cotizacion: {
    cotizacionesUsuario: `${URL_BASE_PHP8}/v1/cotizacion/obtener-cotizaciones-usuario`,
    catalogosCotizador: `${URL_BASE_PHP8}/v1/cotizacion/catalogos-cotizador`,
    actualizarCotizacion: `${URL_BASE_PHP8}/v1/cotizacion/actualizar-cotizacion`,
    resumenCotizacion: `${URL_BASE_PHP8}/v1/cotizacion/resumen-cotizacion`,
    tarifacionCotizacion: `${URL_BASE_PHP8}/v1/cotizacion/tarifacion-cotizacion`,
    guardarPlanes: `${URL_BASE_PHP8}/v1/cotizacion/guardar-planes`,
    getPlanes: `${URL_BASE_PHP8}/v1/cotizacion/get-planes`,
    seccionPago: `${URL_BASE_PHP8}/v1/cotizacion/seccion-pago`,
  },
  emision: {
    datosEmision: `${URL_BASE_PHP8}/v1/emision/datos-emision`,
    pago: `${URL_BASE_PHP8}/v1/emision/pago`,
    seccionCargaContratante: `${URL_BASE_PHP8}/v1/emision/seccion-carga-contratante`,
    seccionCargaAsegurado: `${URL_BASE_PHP8}/v1/emision/seccion-carga-asegurado`,
    listarAsegurados: `${URL_BASE_PHP8}/v1/emision/listar-asegurados`,
    guardarContratante: `${URL_BASE_PHP8}/v1/emision/guardado-contratante`,
    generarVigencia: `${URL_BASE_PHP8}/v1/emision/generar-vigencia-poliza`,
    guardarVigencia: `${URL_BASE_PHP8}/v1/emision/guardar-vigencia-poliza`,
  },
  hogarCommon: {
    generarVigencia: `${URL_BASE_PHP8}/v1/hogar/common/vigencia-poliza`,
    guardarVigencia: `${URL_BASE_PHP8}/v1/hogar/common/save-vigencia-poliza`,
    consultarGo4It: `${URL_BASE_PHP8}/v1/hogar/common/go4-it`,
    descargarPdfGo4It: `${URL_BASE_PHP8}/v1/hogar/common/descargar-pdf-go4-it`,
  },
  pymesCommon: {
    guardarContratante: `${URL_BASE_PHP8}/v1/pymes/common/guardar-contratante`,
    listarAsegurados: `${URL_BASE_PHP8}/v1/pymes/common/listar-asegurados`,
    actualizarAsegurados: `${URL_BASE_PHP8}/v1/pymes/common/actualizar-asegurados`,
    guardarVigenciaPoliza: `${URL_BASE_PHP8}/v1/pymes/common/guardar-vigencia-poliza`,
    generarVigenciaPoliza: `${URL_BASE_PHP8}/v1/pymes/common/generar-vigencia-poliza`,
    recotizar: `${URL_BASE_PHP8}/v1/pymes/common/recotizar`,
  },
};
